
import { Vue, Component, Prop } from "vue-property-decorator";
import Autocomplete from "@/components/form/AutocompleteSuggestion.vue";

@Component({
  components: {
    Autocomplete,
  },
})
export default class FormGroupNew extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: String, default: "Search" }) readonly placeholder!: string;

  handleSelection(selectedItem: any) {
    this.$emit('select', selectedItem);
  }
  handleClear(): void{
    this.$emit('clear');
  }
}
